import { FC, useState } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { ClickAwayListener } from '@mui/material';
import { Link } from 'react-router-dom';
import { BottomMenu, CompanyLogo, TopMenu } from 'dashboard409a/components';
import {
  Bottom,
  CloseButtonContainer,
  CompanyLogoContainer,
  DrawerBottom,
  DrawerContainer,
  StyledCloseButton,
  StyledDrawer,
} from './styles';
import { ISidebar } from './types';


const Sidebar: FC<ISidebar> = props => {
  const { className = '', homePath = '/', topMenuItems, bottomMenuItems, logoUrl = '', isLoading } = props;
  const [isOpen, setIsOpen] = useState(false);
  const drawerWidth = (open: boolean | undefined) => (open ? 300 : 60);
  const width = drawerWidth(false);

  // TODO: Toggle sidebar with Redux
  const handleLeave = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleLeave}>
      <StyledDrawer
        open={false}
        width={width}
        variant="permanent"
        anchor="left"
        onClose={handleLeave}
        PaperProps={{
          elevation: 1,
          style: { overflow: 'visible' },
        }}>
        <DrawerContainer className={className}>
          {/* Close Button */}
          <CloseButtonContainer>
            <StyledCloseButton size="medium" onClick={handleLeave}>
              <CloseIcon />
            </StyledCloseButton>
          </CloseButtonContainer>

          {/* Firm logo */}
          <CompanyLogoContainer>
            <Link to={homePath || '#'}>
              <CompanyLogo logoUrl={logoUrl} />
            </Link>
          </CompanyLogoContainer>

          <DrawerBottom>
            <TopMenu items={topMenuItems} />

            <Bottom>
              <BottomMenu items={bottomMenuItems} isLoading={isLoading} />
            </Bottom>
          </DrawerBottom>
        </DrawerContainer>
      </StyledDrawer>
    </ClickAwayListener>
  );
};

export default Sidebar;